import axios from 'axios';
let mastercreate=[];
let ms_type = '';
let master_name=[];
var xlsx = require('xlsx');
var convert = require('xml-js');
function processExcel(sdata,_this,master_type) {
    var out = xlsx.utils.book_new();
    sdata.forEach(function (xws) {
        var aoa = [[]];
        var rowobj = xws.rows;
        for (var ri = 0; ri < rowobj.len; ++ri) {
            var row = rowobj[ri];
            if (!row) continue;
            aoa[ri] = [];
            /* eslint-disable no-loop-func */
            Object.keys(row.cells).forEach(function (k) {
                var idx = +k;
                if (isNaN(idx)) return;
                aoa[ri][idx] = row.cells[k].text;
            });
        }
        var ws = xlsx.utils.aoa_to_sheet(aoa);
        xlsx.utils.book_append_sheet(out, ws, xws.name);
    });
    processExcelArray(_this,out,master_type);
    //data_render1(out);
}

function processExcelArray(_this,workbook,master_type){
    var XLSX = require('xlsx');
    //Fetch the name of First Sheet.
    // console.log(missing_master);
    var firstSheet = workbook.SheetNames[0];

    //Read all rows from First Sheet into an JSON array.
    var excelRows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet]);

    _this.missing_masters = excelRows;
    _this.IsVisible = true;
     data_render1(_this,_this.modal_popup_template,master_type);
}


function data_render1(_this,obj,master_type) {
     _this.master_create = [];
    ms_type=master_type;
     var template = obj;
 
     $.each(_this.missing_masters, function (k_l,v_l ) {
       var json_data =  JSON.parse(JSON.stringify(obj));
        
        data_render(template, json_data);
        function data_render(template, json_data) {
            if (template, json_data) {
                $.each(template,function(key,value){
                    // if(Array.isArray(value)){
                    //     data_render(template[key],json_data[key])
                    // }
                    if(typeof value == "object"){
                        data_render(template[key],json_data[key])
                    }
                    else{
                        $.each(v_l, function (k,v ) {
                            if (k == value) {
                                json_data[key] = v;
                            }
                        })
                    }
                })
            }
        }
        var options = { compact: true, ignoreComment: true, spaces: 4 };
        if(master_type=="ledger_details"){
            var myXML = '<ENVELOPE>' +
            '<HEADER>' +
            '<TALLYREQUEST>Import Data</TALLYREQUEST>' +
            '</HEADER>' +
            '<BODY>' +
            '<IMPORTDATA>' +
            '<REQUESTDESC>' +
            '<REPORTNAME>All Masters</REPORTNAME>' +
            '</REQUESTDESC>' +
            '<REQUESTDATA>' +
            '<TALLYMESSAGE xmlns:UDF="TallyUDF">' +
            "<LEDGER NAME=" + "\"" + v_l.Name+ "\" Action =" + "\"Create" + "\">" +
            convert.json2xml(JSON.stringify(json_data, true), options) +
            '</LEDGER>' +
            '</TALLYMESSAGE>' +
            '</REQUESTDATA>' +
            '</IMPORTDATA>' +
            '</BODY>' +
            '</ENVELOPE>'
        }
        else if(master_type=="stock_details"){
            var myXML ='<ENVELOPE>' +
            '<HEADER>' +
            '<TALLYREQUEST>Import Data</TALLYREQUEST>' +
            '</HEADER>' +
            '<BODY>' +
            '<IMPORTDATA>' +
            '<REQUESTDESC>' +
            '<REPORTNAME>All Masters</REPORTNAME>' +
            '</REQUESTDESC>' +
            '<REQUESTDATA>' +
            '<TALLYMESSAGE xmlns:UDF="TallyUDF">' +
            "<STOCKITEM NAME=" + "\"" + v_l.Name + "\" Action =" + "\"Create" + "\">" +
            '<NAME>' + v_l.Name + '</NAME>' +
            '<PARENT></PARENT>' +
            '<BASEUNITS>PCS</BASEUNITS>' +
            '</STOCKITEM>' +
            '</TALLYMESSAGE>' +
            '</REQUESTDATA>' +
            '</IMPORTDATA>' +
            '</BODY>' +
            '</ENVELOPE>'
        }
          
        _this.master_create.push(myXML);
        mastercreate.push(JSON.stringify(json_data, true));
        master_name.push(v_l.Name);

       // alert(v_l.Name);
    })


    createMaster(_this,"electron");

}

function createMaster(_this,meta){
    var params={"xml":_this.master_create};
    meta = "electron" ;
    let context = _this ;

    if(meta="electron"){
        var params ={'master_template':mastercreate,'master_name':master_name,'master_type':ms_type};
        console.log("createMasterpara",params);
        window.api.ImportJsonTemplateToTallyMaster(params); 
        window.api.ImportJsonTemplateToTallyMasterReply( (event,res_obj) => {
           // alert(res_obj);
            context.$emit('close');
        
                    // _this.ledgername_ver =res_obj.ledger;
                    // _this.stockitem_ver =res_obj.stock;
                    // _this.ledgername_count =  _this.ledgername_ver.filter(item => item.status === "dont_exists").length;
                    // _this.stockitem_count =  _this.stockitem_ver.filter(item => item.status === "dont_exists").length;
                    //$scope.voucher_ver_count = vouch_res.filter(item => item.status === "dont_exists").length;
                    //$scope.voucher_ver_count = vouch_res.filter(item => item.status === "dont_exists").length;
        }); 
    }
    else{
        axios.post('insert_master_xml',params)
        .then((response)=>{
                //   console.log(response);
         })
    }
   
}



export{processExcel,createMaster}